








































import Vue from 'vue'
import * as GoogleMaps from 'vue2-google-maps'
import { Polyline as TripLine } from 'vue2-google-maps'
import GoogleConfig from '@/config/google'
import { nightmode } from '@/components/Map/styles'
import selectedMarker from '@/assets/markers/marker-selected-md.png'
import movingMarker from '@/assets/markers/marker-moving-md.png'
import { tracefyBlue } from '@/plugins/vuetify'
import { apiGetConsumerEntity, apiGetDebugEntityDetails, apiUpdateDebugConsent } from '@/api'

import MapDebugDrawer from '@/components/DebugMap/MapDebugDrawer.vue'
import Trip from '@/components/DebugMap/Trip.vue'
import { CUSTOMER_CONSENT_COOKIE_PREFIX } from '@/constants'
import { mutations } from '@/state'

Vue.use(GoogleMaps, {
  load: {
    key: GoogleConfig.apiKey,
    libraries: GoogleConfig.libraries
  }
})

export default Vue.extend({
  name: 'DebugMap',
  components: { MapDebugDrawer, TripLine, Trip },
  computed: {
    options () {
      if (this.$vuetify.theme.dark) {
        return { ...this.mapOptions, styles: nightmode }
      } else {
        return { ...this.mapOptions, styles: [] }
      }
    }
  },
  data () {
    return {
      hasCustomerConsent: false,
      drawerOpened: false,
      entity: null,
      markerData: null,
      position: { lat: 52.03050336, lng: 5.278821665 },
      noPastLocation: false,
      zoom: 4,
      token: null,
      margin: 100,
      selectedMarker,
      movingMarker,
      tracefyBlue
    }
  },
  methods: {
    async consentSweetAlert () {
      return await this.$swal({
        title: this.t({ s: 'consentDialog.title', component: 'ImeiStatus' }),
        text: this.t({ s: 'consentDialog.text', component: 'ImeiStatus' }),
        icon: 'warning',
        showCloseButton: false,
        showCancelButton: true,
        cancelButtonText: this.t({ s: 'consentDialog.cancel', component: 'ImeiStatus' }),
        confirmButtonText: this.t({ s: 'consentDialog.confirm', component: 'ImeiStatus' }),
        confirmButtonColor: '#1cad73',
        allowOutsideClick: false,
        customClass: {
          title: this.$vuetify.theme.dark ? 'swal2-dark' : '',
          container: this.$vuetify.theme.dark ? 'swal2-dark' : '',
          content: this.$vuetify.theme.dark ? 'swal2-dark' : ''
        }
      })
    },
    moveToMarker() {
      this.$refs.debugMap.$mapObject.setCenter(this.$refs.debugMapMarker.$markerObject.getPosition())
    },
    locationUpdateHandler(update: any) {
      const { position, margin } = update
      this.position = position
      this.margin = margin
      this.noPastLocation = false
      this.$refs.debugMapMarker.$markerObject.setIcon(this.movingMarker)
      this.moveToMarker()
    },
    clearRenderedTrip() {
      if (!this.$refs.debugMapTrip.trip) return
      this.$refs.debugMapTrip.clearRenderedTrip()
      this.position = this.entity.position
      this.moveToMarker()
    },
    getEntityDetails(entityId: string) {
      apiGetDebugEntityDetails(entityId).then((res) => {
        this.hasCustomerConsent = true
        const entity = res.data.data
        const { latitude: lat, longitude: lng } = entity.location

        this.entity = {
          ...entity,
          sub_vendor_name: entity.business,
          position: entity.location
        }
        this.drawerOpened = true
        this.zoom = 16

        if (!lat || !lng) {
          this.noPastLocation = true
          this.position = { lat: 0, lng: 0 }
        }

        this.position = { lat, lng }
      }).catch(e => mutations.setSnackbar('error', e.response.data.message))
    },
    hasConsentToken(token: string | undefined) {
      if (!token) return false
      const localConsentToken = this.getCookie(`${CUSTOMER_CONSENT_COOKIE_PREFIX}${this.entityId}`)
      if (localConsentToken === token) return true
      return false
    },
    async confirmCustomerConsent() {
      const res = await apiGetConsumerEntity(this.entityId)
      const { consumer_entity, token } = res.data.data

      if (!consumer_entity || this.hasConsentToken(token)) {
        await this.getEntityDetails(this.entityId)
        return
      }

      const { isConfirmed } = await this.consentSweetAlert()

      if (!isConfirmed) {
        this.$router.back()
        return
      }

      this.setCookie(`${CUSTOMER_CONSENT_COOKIE_PREFIX}${this.entityId}`, token, 1)
      await apiUpdateDebugConsent(this.entityId).catch(e => mutations.setSnackbar('error', e.response.data.message))
      await this.getEntityDetails(this.entityId)
    }
  },
  mounted() {
    const entityId = this.$route.params.id
    if (entityId.length !== 36 || typeof entityId !== 'string') {
      this.$router.back()
      mutations.setSnackbar('error', 'Invalid entity id!')
    }
    this.entityId = entityId
    this.confirmCustomerConsent()
  }
})

